import { render } from "./PanelStartConversationButtonAndModal.vue?vue&type=template&id=6594afad&scoped=true"
import script from "./PanelStartConversationButtonAndModal.vue?vue&type=script&lang=js"
export * from "./PanelStartConversationButtonAndModal.vue?vue&type=script&lang=js"

import "./PanelStartConversationButtonAndModal.vue?vue&type=style&index=0&id=6594afad&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6594afad"]])

export default __exports__